import { normalizeSearch } from "/app/src/routes/{-$locale}/builds/$id/files.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/builds/$id/files.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { buildComparisonQueryOptions, buildFileTreeQueryOptions, buildHistoryQueryOptions, buildQueryOptions } from "@/queries/build-details";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
type BuildFilesSearch = {
  view: "changes" | "all";
  compare?: string;
  status?: string;
  q?: string;
  extension?: string;
  path?: string;
  page: number;
};
export const Route = createFileRoute("/{-$locale}/builds/$id/files")({
  validateSearch: normalizeSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loaderDeps: ({
    search
  }) => search,
  loader: async ({
    params,
    context,
    deps
  }) => {
    const {
      id
    } = params;
    await Promise.allSettled([context.queryClient.ensureQueryData(buildHistoryQueryOptions(id)), context.queryClient.ensureQueryData(buildQueryOptions(id))]);
    if (deps.view === "all") {
      await Promise.allSettled([context.queryClient.ensureQueryData(buildFileTreeQueryOptions(id, {
        path: deps.path,
        page: deps.page,
        limit: 100
      }))]);
    } else if (deps.compare) {
      await Promise.allSettled([context.queryClient.ensureQueryData(buildComparisonQueryOptions(id, deps.compare, {
        page: deps.page,
        q: deps.q,
        extension: deps.extension,
        status: deps.status
      }))]);
    }
    return {
      id,
      dehydratedState: dehydrate(context.queryClient)
    };
  }
});
type UpdateSearch = (updates: Partial<BuildFilesSearch>, replace?: boolean) => void;